<template>
    <div>
        <el-tabs v-model="activeTab" type="border-card">
            <!-- ============ 页签1：系统操作日志 ============ -->
            <el-tab-pane label="系统操作日志" name="log">
                <div style="margin-bottom: 5px;">
                    <el-input v-model="keyword" placeholder="请输入操作人姓名/账号" suffix-icon="el-icon-search"
                              style="width: 200px;" @keyup.enter.native="loadPost"></el-input>
                    <el-select v-model="actionFilter" placeholder="操作类型" style="margin-left: 5px; width: 120px;">
                        <el-option v-for="item in actionOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-model="targetTypeFilter" placeholder="对象类型" style="margin-left: 5px; width: 120px;">
                        <el-option v-for="item in targetTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                    <el-button type="primary" style="margin-left: 5px;" @click="loadPost">查询</el-button>
                    <el-button type="success" @click="resetParam">重置</el-button>
                    <span style="margin-left: 10px; color: #999; font-size: 12px;">记录管理员/超级管理员对用户、商品、分类的增删改与设折扣操作</span>
                </div>
                <el-table :data="tableData"
                          :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                          border>
                    <el-table-column prop="id" label="ID" width="60"></el-table-column>
                    <el-table-column label="操作人" width="140">
                        <template slot-scope="scope">
                            <span>{{scope.row.operatorName || '-'}}</span>
                            <span style="color: #999; font-size: 12px; margin-left: 5px;">（{{scope.row.operatorNo}}）</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="角色" width="100">
                        <template slot-scope="scope">
                            <el-tag :type="roleType(scope.row.operatorRole)" disable-transitions>
                                {{roleName(scope.row.operatorRole)}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作类型" width="100">
                        <template slot-scope="scope">
                            <el-tag :type="actionType(scope.row.action)" disable-transitions>{{scope.row.action}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="对象类型" width="90">
                        <template slot-scope="scope">
                            <span>{{scope.row.targetType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="targetName" label="对象" width="180" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="detail" label="操作详情" min-width="260" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="createTime" label="操作时间" width="170"></el-table-column>
                </el-table>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNum"
                        :page-sizes="[5, 10, 20, 30]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </el-tab-pane>

            <!-- ============ 页签2：购买记录 ============ -->
            <el-tab-pane label="购买记录" name="order">
                <div style="margin-bottom: 5px;">
                    <el-button type="primary" style="margin-left: 5px;" @click="loadOrders">刷新</el-button>
                    <span style="margin-left: 10px; color: #999; font-size: 12px;">物语小店全部成员购买记录（含商品明细与成交单价）</span>
                </div>
                <el-table :data="orderData"
                          :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
                          border>
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table :data="props.row.items" border size="mini">
                                <el-table-column prop="productId" label="商品ID" width="80"></el-table-column>
                                <el-table-column prop="productName" label="商品名" width="220"></el-table-column>
                                <el-table-column label="成交单价" width="120">
                                    <template slot-scope="s">￥{{ Number(s.row.price).toFixed(2) }}</template>
                                </el-table-column>
                                <el-table-column prop="count" label="数量" width="80"></el-table-column>
                                <el-table-column label="小计" width="120">
                                    <template slot-scope="s">￥{{ (Number(s.row.price) * s.row.count).toFixed(2) }}</template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </el-table-column>
                    <el-table-column prop="order.id" label="订单号" width="80"></el-table-column>
                    <el-table-column prop="order.userNo" label="账号" width="150"></el-table-column>
                    <el-table-column prop="order.userName" label="昵称" width="130"></el-table-column>
                    <el-table-column label="商品数" width="90">
                        <template slot-scope="scope">
                            {{(scope.row.items || []).reduce((sum, it) => sum + it.count, 0)}} 件
                        </template>
                    </el-table-column>
                    <el-table-column label="订单总价" width="110">
                        <template slot-scope="scope">
                            <span style="color: #e0539c; font-weight: 600;">￥{{ Number(scope.row.order.totalAmount).toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="order.createTime" label="购买时间" width="170"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    export default {
        name: "OperationLog",
        data() {
            return {
                user: JSON.parse(sessionStorage.getItem('CurUser') || '{}'),
                activeTab: 'log',
                tableData: [],
                orderData: [],
                pageSize: 10,
                pageNum: 1,
                total: 0,
                keyword: '',
                actionFilter: '',
                targetTypeFilter: '',
                actionOptions: [
                    {value: '', label: '全部类型'},
                    {value: '新增', label: '新增'},
                    {value: '修改', label: '修改'},
                    {value: '删除', label: '删除'},
                    {value: '设置折扣', label: '设置折扣'},
                    {value: '设置展示', label: '设置展示'}
                ],
                targetTypeOptions: [
                    {value: '', label: '全部对象'},
                    {value: '用户', label: '用户'},
                    {value: '商品', label: '商品'},
                    {value: '分类', label: '分类'}
                ]
            }
        },
        methods: {
            roleName(roleId) {
                if (roleId === 0 || roleId === '0') return '超级管理员'
                if (roleId === 1 || roleId === '1') return '管理员'
                return '普通用户'
            },
            roleType(roleId) {
                if (roleId === 0 || roleId === '0') return 'danger'
                if (roleId === 1 || roleId === '1') return 'warning'
                return 'success'
            },
            actionType(action) {
                if (action === '删除') return 'danger'
                if (action === '设置折扣' || action === '设置展示') return 'warning'
                if (action === '修改') return 'primary'
                return 'success'
            },
            handleSizeChange(val) {
                this.pageNum = 1
                this.pageSize = val
                this.loadPost()
            },
            handleCurrentChange(val) {
                this.pageNum = val
                this.loadPost()
            },
            resetParam() {
                this.keyword = ''
                this.actionFilter = ''
                this.targetTypeFilter = ''
            },
            loadPost() {
                this.$axios.post(this.$httpUrl + '/sysLog/listPage', {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {
                        keyword: this.keyword,
                        action: this.actionFilter,
                        targetType: this.targetTypeFilter
                    }
                }).then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.tableData = res.data
                        this.total = res.total
                    } else {
                        this.$message.error('获取数据失败')
                    }
                })
            },
            loadOrders() {
                this.$axios.get(this.$httpUrl + '/shop/admin/orders').then(res => res.data).then(res => {
                    if (res.code == 200) {
                        this.orderData = res.data
                    } else {
                        this.$message.error('获取数据失败')
                    }
                })
            }
        },
        beforeMount() {
            this.loadPost()
            this.loadOrders()
        }
    }
</script>

<style scoped>

</style>
